<template>
    <Card>
        <template v-slot:title>
            {{ __('orders.by_weekday') }}
        </template>

        <div class="d-flex flex-column justify-content-center h-100">
            <div class="d-flex flex-row justify-content-center align-items-center w-100 gap-2">
                <div v-for="(orderCount, weekday) in statistics.orders_by_weekday"
                     class="flex-grow-1 text-center px-1 mx-n1 py-4 my-n4 rounded user-select-none cursor-default"
                     :class="{
                        'bg-hover-light-light': weekday !== currentDayIndex,
                        'bg-light-primary text-primary bg-hover-primary text-hover-white': weekday === currentDayIndex,
                    }"
                >
                    <div class="font-weight-bold text-lg text-uppercase">
                        {{ getWeekdayName(weekday) }}
                    </div>
                    <div class="text-2xl mt-1"
                         :class="{'opacity-50 font-weight-light': orderCount === 0 && weekday !== currentDayIndex}">
                        {{ orderCount }}
                    </div>
                </div>
            </div>
        </div>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";

export default {
    components: {Card},

    props: {
        statistics: Object
    },

    methods: {
        getPercentage(orderCount) {
            if (this.statistics.total_orders === 0) {
                return 0;
            }

            return orderCount * 100 / this.statistics.total_orders;
        },

        getWeekdayName(weekdayIndex) {
            switch (weekdayIndex) {
                case '1':
                    return __('date.short.monday');
                case '2':
                    return __('date.short.tuesday');
                case '3':
                    return __('date.short.wednesday');
                case '4':
                    return __('date.short.thursday');
                case '5':
                    return __('date.short.friday');
                case '6':
                    return __('date.short.saturday');
                case '7':
                    return __('date.short.sunday');

                default:
                    return weekdayIndex;
            }
        }
    },

    computed: {
        currentDayIndex() {
            return '' + new Date().getDay();
        }
    }
}
</script>
